<div *ngIf="isOpen" class="dialog-overlay">
  <div class="dialog-backdrop" (click)="onCancel()"></div>
  <div class="dialog-box">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ title }}</h2>
    </div>

    <div class="dialog-body">
      <p class="dialog-message" *ngIf="!messageHtml">{{ message }}</p>
      <p class="dialog-message" *ngIf="messageHtml" [innerHTML]="messageHtml"></p>
      <!-- Optional extra content (inputs etc.) projected by the caller -->
      <ng-content></ng-content>
    </div>

    <div class="dialog-actions">
      <emerald-button
        [label]="cancelLabel"
        [type]="'Secondary'"
        (onClick)="onCancel()">
      </emerald-button>
      <emerald-button
        [label]="submitLabel"
        [type]="'Primary'"
        [disabled]="submitDisabled"
        (onClick)="onConfirm()">
      </emerald-button>
    </div>
  </div>
</div>